import { createFileRoute } from '@tanstack/react-router';
import { JourneysDataIndexIndexHandoff } from '@/pages/workspaces/data-index/routing';
import { LastWorkspaceResolver } from './-route-helpers';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/data-index/')({
  component: () => (
    <LastWorkspaceResolver>
      <JourneysDataIndexIndexHandoff />
    </LastWorkspaceResolver>
  ),
});
